export enum ECommandResult {
  SUCCESS = 0,
  ERROR = 1,
  ALERT = 2
}
